<template lang='pug'>
span
  v-row(
    v-if='loading'
    style='height: 100%; justify-content: center; align-items: center')
    v-col(cols='auto')
      v-progress-circular(
        size='250'
        width='6'
        indeterminate
        color='rgba(200, 200, 200, 0.7)')
        b(style='font-size: 17px; font-weight: 700; color: rgba(0, 0, 0, 0.3)') {{$t('confirmationStep.importingWorkspace')}}
  v-row(
    v-else
    no-gutters
    style='padding: 0; height: 100%; justify-content: center; align-items: center;')
    v-col(cols='auto')
      template(v-if='!importError')
        img(
          src='@/assets/img/check-underline-circle.png',
          :class='anmtImgClass'
          style='height: 256px; width: 256px; display: block; transition: .5s')
        .titleLabel.colorDark(
          :class='anmtTxtClass'
          style='text-align: center; transition: .2s') {{$t('confirmationStep.approved')}}
      template(v-else)
        img(
          src='@/assets/img/close-circle.png',
          :class='anmtImgClass'
          style='height: 256px; width: 256px; display: block; transition: .5s')
        .titleLabel.colorDark(
          :class='anmtTxtClass'
          style='text-align: center; transition: .2s') {{$t('confirmationStep.error')}}
        .titleLabel.colorDark(
          :class='anmtTxtClass'
          style='text-align: center; transition: .2s') {{ importError.message }}
</template>

<script>
export default {
  name: 'ConfirmationStep',
  props: {
    finished: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    importError: {
      type: Object,
      default: null
    }
  },
  watch: {
    finished (nV) {
      if (!nV) {
        this.anmtImgClass = 'size-hidden'
        this.anmtTxtClass = 'opacity-hidden'
      }
    },
    loading (nV) {
      if (!nV) {
        setTimeout(() => {
          this.anmtImgClass = 'size-110'
          setTimeout(() => {
            this.anmtImgClass = 'size-100'
            this.anmtTxtClass = 'opacity-100'
            // console.log('tamanho 100')
          }, 500)
          // console.log('tamanho 110')
        }, 200)
      }
    }
  },
  data () {
    return {
      anmtImgClass: 'size-hidden',
      anmtTxtClass: 'opacity-hidden'
    }
  }
}
</script>

<style scoped>
.size-hidden {
  transform: scale(0);
}
.size-110 {
  transform: scale(1.1);
}
.size-100 {
  transform: scale(1);
}
.opacity-hidden {
  opacity: 0;
}
.opacity-100 {
  opacity: 100%;
}
</style>
